<div [class.is-expanded]="isExpanded" class="line-item-accordion">
  <!-- HEADER -->
  <div class="line-item-header flex justify-between items-center">
    <div (click)="toggleExpand.emit()" class="left flex flex-row justify-start items-center gap-[12px] grow cursor-pointer">
      <div class="details">
        <div class="heading text-type-8">{{ formatDate(lineItem?.created_at) }}</div>
      </div>
    </div>
    <div class="right flex justify-center items-center gap-[20px]">
      <div class="chevron">
        <mat-icon
          (click)="toggleExpand.emit()"
          [svgIcon]="isExpanded ? 'chevron-up' : 'chevron-down'"
          class="chevron-icon"
        />
      </div>
      <div class="menu-section">
        @if (editable) {
          <mat-icon
            [matMenuTriggerFor]="lineItemMenu"
            class="menu-icon"
            >more_horiz
          </mat-icon>
          <mat-menu #lineItemMenu="matMenu">
            <button (click)="deleteClicked.emit()" mat-menu-item>
              <mat-icon svgIcon="trash" />
              Delete
            </button>
          </mat-menu>
        }
      </div>
    </div>
  </div>

  <!-- BODY (visible when expanded) -->
  <div class="line-item-content" [formGroup]="form">
    <!-- 1. CONTRACTOR -->
    <app-dropdown
      (addNewClicked)="addContractorClicked.emit()"
      [addNewLabel]="'Add contractor to report'"
      [enableAddNew]="showAddContractorButton"
      [enableSearch]="contractorOptions.length >= 10"
      [error]="errorMessages['contractor']"
      [options]="contractorOptions"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="contractor"
      label="Contractor"
    />

    <!-- 2. LOCATION STATION SECTION -->
    <div class="location-station-section mb-[40px]">
      <div class="location-station-header flex justify-between items-center mb-[12px]">
        <div class="location-station-label">Location station:</div>
        @if (editable) {
          <mat-icon
            [matMenuTriggerFor]="locationStationMenu"
            class="location-station-menu-icon"
            >more_horiz
          </mat-icon>
        }
        <!-- Menu stays outside the @if so both triggers (header icon and the
             "Add location or station" prompt below) can reference it. -->
        <mat-menu #locationStationMenu="matMenu">
          <button (click)="openLocationPicker()" mat-menu-item>
            <mat-icon svgIcon="marker-outline" />
            Add location
          </button>
          <button (click)="openStationPopup()" mat-menu-item>
            <mat-icon svgIcon="plus" />
            Add station
          </button>
          @if (hasLocationOrStation) {
            <button (click)="deleteLocation()" mat-menu-item>
              <mat-icon svgIcon="trash" />
              Clear
            </button>
          }
        </mat-menu>
      </div>

      @if (!hasLocationOrStation && editable) {
        <div
          [matMenuTriggerFor]="locationStationMenu"
          class="empty-location-station flex flex-row flex-wrap justify-start items-center"
          [class.error-border]="showLocationStationError"
        >
          <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
          Add location or station
        </div>
        @if (showLocationStationError) {
          <div class="location-station-error">Location or station is required</div>
        }
      }

      @if (hasLocationOrStation) {
        <div class="location-station-box">
          <!-- LOCATION MAP -->
          @if (form.controls['latitude']?.value && form.controls['longitude']?.value && !stationRangeMapData) {
            <div (click)="openLocationPicker()" class="location-map-section mb-[20px] cursor-pointer">
              <app-location-section
                (onDelete)="deleteLocation()"
                [hideLabel]="true"
                [isEditable]="editable"
                [latitude]="form.controls['latitude']?.value"
                [longitude]="form.controls['longitude']?.value"
              />
              @if (form.controls['location']?.value) {
                <div class="location-text-section mt-[12px]">
                  <div class="location-label text-type-15 mb-[4px]">Location:</div>
                  <div class="location-text text-type-11">{{ form.controls['location']?.value }}</div>
                </div>
              }
            </div>
          }

          @if (!(form.controls['latitude']?.value && form.controls['longitude']?.value) && form.controls['location']?.value && !stationRangeMapData) {
            <div (click)="openLocationPicker()" class="location-text-section mb-[20px] cursor-pointer">
              <div class="location-label text-type-15 mb-[4px]">Location:</div>
              <div class="location-text text-type-11">{{ form.controls['location']?.value }}</div>
            </div>
          }

          @if (stationRangeMapData) {
            <div (click)="editable && openStationPopup()" [class.cursor-pointer]="editable" class="station-range-map-section mb-[20px]">
              <app-survey-data-map [geometry]="stationRangeMapData.geometry" />
              @if (stationRangeMapData.fromLabel) {
                <div class="station-map-label station-map-label-from">{{ stationRangeMapData.fromLabel }}</div>
              }
              @if (stationRangeMapData.toLabel) {
                <div class="station-map-label station-map-label-to">{{ stationRangeMapData.toLabel }}</div>
              }
            </div>
          }

          <!-- STATION FROM/TO -->
          @if (currentStationRange) {
            <div (click)="editable && openStationPopup()" [class.cursor-pointer]="editable" class="station-details">
              @if (currentStationRange.from?.station || currentStationRange.from?.offsetType || currentStationRange.from?.offsetDistance) {
                <div class="from mb-[20px]">
                  <div class="station-range-sub-section-label text-type-15">From:</div>
                  <div class="from-details text-type-11">
                    {{ currentStationRange.from?.station }}
                    @if (currentStationRange.from?.offsetType) {
                      <span>, {{ currentStationRange.from?.offsetType }}</span>
                    }
                    @if (currentStationRange.from?.offsetDistance) {
                      <span>, {{ currentStationRange.from?.offsetDistance }}</span>
                    }
                  </div>
                </div>
              }
              @if (currentStationRange.to?.station || currentStationRange.to?.offsetType || currentStationRange.to?.offsetDistance) {
                <div class="to">
                  <div class="station-range-sub-section-label text-type-15">To:</div>
                  <div class="to-details text-type-11">
                    {{ currentStationRange.to?.station }}
                    @if (currentStationRange.to?.offsetType) {
                      <span>, {{ currentStationRange.to?.offsetType }}</span>
                    }
                    @if (currentStationRange.to?.offsetDistance) {
                      <span>, {{ currentStationRange.to?.offsetDistance }}</span>
                    }
                  </div>
                </div>
              }
            </div>
          }

        </div>
      }
    </div>

    <!-- 3. QUANTITY -->
    <app-number-input
      [decimalPlaces]="quantityRounding"
      [isDecimalAllowed]="true"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="quantity"
      [label]="'Quantity (' + uom + ')'"
    />

    <!-- 4. AREA CALCULATION / CUSTOM GROUPS -->
    @for (group of areaCalculationGroups; track group.context) {
      <div class="area-calculation-section mb-[40px]">
        <div class="area-calc-header flex justify-between items-center mb-[12px]">
          <div class="area-calc-label">{{ group.label || 'Calculate area' }}:</div>
          @if (getAreaCalculationCardInfo(group).length && editable) {
            <mat-icon
              [matMenuTriggerFor]="areaCalcMenu"
              class="area-calc-menu-icon"
            >more_horiz</mat-icon>
            <mat-menu #areaCalcMenu="matMenu">
              <button (click)="deleteAreaCalculation(group)" mat-menu-item>
                <mat-icon svgIcon="trash" />
                Delete {{ group.label?.toLowerCase() || 'area calculation' }}
              </button>
            </mat-menu>
          }
        </div>
        @if (!getAreaCalculationCardInfo(group).length) {
          @if (editable) {
            <div (click)="openAreaCalculationDialog(group)" class="area-calc-prompt flex flex-row items-center cursor-pointer">
              <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
              {{ group.label || 'Calculate area' }}
            </div>
          }
        } @else {
          <div (click)="editable && openAreaCalculationDialog(group)" [class.cursor-pointer]="editable" class="area-calc-card">
            @for (cardItem of getAreaCalculationCardInfo(group); track $index) {
              <div class="area-calc-card-item">
                <div class="area-calc-card-title text-type-8">{{ cardItem.title | sentenceCase }}</div>
                @if (cardItem.description) {
                  <div class="area-calc-card-description text-type-15">{{ cardItem.description }}</div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- 5. MATERIAL SET SECTION -->
    @if (materialSets.length) {
      <div class="material-set-section mb-[40px]">
        <div class="material-set-header flex justify-between items-center mb-[12px]">
          <div class="material-set-label">Materials:</div>
          @if (materialSetData && editable) {
            <mat-icon
              [matMenuTriggerFor]="materialSetMenu"
              class="material-set-menu-icon"
            >more_horiz</mat-icon>
            <mat-menu #materialSetMenu="matMenu">
              <button (click)="deleteMaterialSet()" mat-menu-item>
                <mat-icon svgIcon="trash" />
                Delete material set
              </button>
            </mat-menu>
          }
        </div>
        @if (!materialSetData) {
          @if (editable) {
            <div (click)="openMaterialSetDialog()" class="material-set-prompt flex flex-row items-center cursor-pointer">
              <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
              Add material set
            </div>
          }
        } @else {
          <div (click)="editable && openMaterialSetDialog()" [class.cursor-pointer]="editable" class="material-set-card">
            <div class="material-set-name text-type-8">{{ materialSetData.materialSetName | sentenceCase }}</div>
            @for (mat of materialSetData.materials; track mat.material_id) {
              <div class="material-item text-type-15">
                {{ mat.material?.name }}: {{ mat.quantity }}
              </div>
            }
          </div>
        }
      </div>

      <!-- 6. ACCEPTANCE RECORD SECTION -->
      <!-- Always render the acceptance-record card (custom_field group config
           for `report_material_acceptance_record` — field_inspection_value,
           action_type, comments, etc.). For sample-collection orgs the
           embedded Samples list renders below it. -->
      @if (materialSetData?.materials?.length) {
        <div class="acceptance-record-section mb-[40px]">
          <div class="acceptance-record-header flex justify-between items-center mb-[12px]">
            <div class="acceptance-record-label">Acceptance fields:</div>
            @if (hasAcceptanceRecordData() && editable) {
              <mat-icon
                [matMenuTriggerFor]="acceptanceRecordMenu"
                class="acceptance-record-menu-icon"
              >more_horiz</mat-icon>
              <mat-menu #acceptanceRecordMenu="matMenu">
                <button (click)="deleteAcceptanceRecord()" mat-menu-item>
                  <mat-icon svgIcon="trash" />
                  Delete acceptance record
                </button>
              </mat-menu>
            }
          </div>
          @if (!hasAcceptanceRecordData()) {
            @if (editable) {
              <div (click)="openAcceptanceRecordDialog()" class="acceptance-record-prompt flex flex-row items-center cursor-pointer">
                <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
                Add acceptance fields
              </div>
            }
          } @else {
            <div (click)="editable && openAcceptanceRecordDialog()" [class.cursor-pointer]="editable" class="acceptance-record-card">
              @for (mat of materialSetData.materials; track mat.material_id) {
                @let summaries = getAcceptanceRecordSummaries(mat);
                @if (summaries.length) {
                  <div class="acceptance-material-item">
                    <div class="acceptance-material-name text-type-8">{{ mat.material?.name | sentenceCase }}</div>
                    @for (summary of summaries; track summary.index) {
                      <div class="acceptance-record-entry">
                        @if (summaries.length > 1) {
                          <div class="acceptance-record-entry-label">Record {{ summary.index + 1 }}</div>
                        }
                        <div class="acceptance-values text-type-15">{{ summary.text }}</div>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>

      }
    }

    <!-- 7. COMMENT -->
    @if (form.controls['comment']) {
      <app-text-area
        [parentFormGroup]="form"
        class="mb-[40px]"
        controlName="comment"
        label="COMMENT"
      />
    }

    <!-- 8. PICTURES / MEDIA -->
    @if (mediaFiles.length) {
      <app-pictures-section
        (onDelete)="deletePicture($event)"
        [isEditable]="editable"
        [pictures]="mediaFiles"
        class="pictures-section mb-[40px]"
      />
    }
  </div>
</div>
